import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ApiService} from '../api/api.service';
import {LoggerService} from '../shared/logger.service';
import {HttpClient} from '@angular/common/http';
import {GridResponse} from '../models/models.lib';
import {map, tap} from 'rxjs/operators';

export abstract class CasiResearchDataExportService extends BehaviorSubject<GridResponse | null> {
  public loading: boolean = false;
  public apiService = inject(ApiService);
  private loggerService = inject(LoggerService);

  constructor(
    private http: HttpClient,
  ) {
    super(null);
  }

  public query(body: any): void {
    this.fetch(body).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(body: any): Observable<GridResponse> {
    this.loading = true;

    return this.apiService.insertCsrf('/placement/review/research/data', 'POST', body)
      .pipe(
        map((response: any) => GridResponse.create(response)),
        tap(() => {
          this.loading = false;
        })
      );
  }
}

@Injectable({
  providedIn: 'root'
})
export class ResearchDataExportService extends CasiResearchDataExportService{
  constructor(
    http: HttpClient
  ) {
    super(http)
  }

  get(body: any) {
    return this.apiService.postHttpCall(`/placement/review/research/data`, body, 'get');
  }
}
